<template>
<div class="row">
    <div class="col-12">
        <h2>Materiais para Download</h2>
        <div class="row mt-3">
            <div class="col-md-12">
                <b-button variant="success" size="sm" @click="showModal(-1)">
                    <i class="fa fa-plus"></i> Adicionar Material
                </b-button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="mt-3 card p-3">
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th class="text-center">id</th>
                                <th class="text-center">Descrição</th>
                                <th class="text-center">Região</th>
                                <th class="text-center">Classe</th>
                                <th class="text-center">Arquivo</th>
                                <th class="text-center">Editar</th>
                                <th class="text-center">Deletar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(material, index) in materiaisDownload" :key="index">
                                <td>{{ material.id }}</td>
                                <td>{{ material.descricao }}</td>
                                <td>{{ material.regiao ? material.regiao : "" }}</td>
                                <td>{{ material.classe }}</td>
                                <td class="text-center">
                                    <a target="_blank" :href="'/storage/' + material.path">
                                        <i class="fas fa-file fa-lg"></i>
                                    </a>
                                </td>
                                <td class="text-center">
                                    <b-button variant="primary" @click="showModal(index)">
                                        <i class="fa fa-edit"></i>
                                    </b-button>
                                </td>
                                <td class="text-center">
                                    <b-button variant="danger" @click="deleteMaterial(index)">
                                        <i class="fas fa-trash-alt"></i>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- **************** Início Modais ****************** -->
    <b-modal v-model="openedModal" size="lg" :title="criar ? 'Adicionar Material para Download' : 'Editar Material para Download'">
        <b-card>
            <b-card-body>
                <div class="form-group">
                    <label for="">Descrição</label>
                    <input type="text" class="form-control" v-model="newMaterialDownload.descricao" />
                    <label for="">Classes</label>
                    <input type="text" class="form-control" v-model="newMaterialDownload.classe" />
                </div>
                <v-tag :regioes="regioes" @alteraRegiao="alteraRegiao" />
                
                <div v-if="!arquivoUpload" class="mt-3">
                    <h6 v-if="criar">
                        Escolha um Arquivo. <small>(limite de 60 MB)</small>
                    </h6>
                    <h6 v-else>
                        Escolha um novo Arquivo. <small>(limite de 60 MB)</small>
                    </h6>
                    <b-form-file @change="onFileChange" placeholder="Selecione um Arquivo..."></b-form-file>
                </div>
                <div v-else class="mt-3">
                    {{ arquivoUpload }}
                    <b-button variant="danger" size="sm" @click="removeImage">Remover Arquivo</b-button>
                </div>
            </b-card-body>
        </b-card>
        <template #modal-footer>
            <b-button variant="primary" size="sm" class="float-right mr-2" @click.prevent="postMaterial" v-if="criar && !statusEnviando">Enviar</b-button>
            <b-button variant="primary" size="sm" class="float-right mr-2" @click.prevent="postMaterial" v-if="!criar && !statusEnviando">Salvar</b-button>
            <b-button variant="warning" size="sm" class="float-right mr-2" disabled="" v-if="statusEnviando"> <i class="fa fa-spinner fa-spin fa-fw"></i> Enviado... </b-button>
            <b-button variant="danger" size="sm" class="float-right mr-2" @click="openedModal = false"> Fechar </b-button>
        </template>
    </b-modal>
</div>
</template>

<script>
export default {
    props: ["propertie"],
    data() {
        return {
            newMaterialDownload: {
                descricao: "",
                classe: "",
                file: ""
            },
            descricao: "",
            classe: "",
            arquivoUpload: "",
            materiaisDownload: [],
            criar: false,
            currentIndex: -1,
            statusEnviando: false,
            regioes: [],
            dataRegioes: {},
            estados: [],
            openedModal: false,
        };
    },
    methods: {
        loadRegioes() {
            var vm = this;
            $(".loading").show();
            axios("/estados")
                .then(function (response) {
                    vm.estados = response.data;
                    response.data.forEach(function (item) {
                        vm.dataRegioes[item.id] = item.uf;
                    });
                    vm.eventRegioes();
                    $(".loading").hide();
                })
                .catch(function (error) {
                    console.log(error);
                    $(".loading").hide();
                });
        },
        eventRegioes() {
            this.$emit("tag-update", {
                id: "tag-regioes",
                data: this.dataRegioes,
                model: this.regioes,
            });
        },
        load() {
            this.clear();
            var vm = this;
            vm.openedModal = false;
            axios
                .get("/adm/material_download/listar")
                .then((response) => {
                    vm.materiaisDownload = response.data;
                })
                .catch((error) => {
                    alert("houve uma falha");
                    //console.log(error);
                });
        },
        showModal(index) {
            this.clear();
            if (index >= 0) {
                this.criar = false;
                this.currentIndex = index;
                this.newMaterialDownload.descricao =
                    this.materiaisDownload[index].descricao;
                this.newMaterialDownload.classe =
                    this.materiaisDownload[index].classe;
                var regioes = this.materiaisDownload[index].regiao ?
                    this.materiaisDownload[index].regiao.split(",") : [];
                if (regioes.length > 0) {
                    this.regioes = [];
                    var vm = this;
                    regioes.forEach(function (value) {
                        //console.log("varrendo regioes..." + value);
                        //console.log(vm.dataRegioes);
                        for (var i = 1; vm.estados.length > i; i++) {
                            if (vm.estados[i].uf === value) {
                                vm.regioes.push(vm.estados[i].id);
                            }
                        }
                    });
                }
            } else {
                this.currentIndex = -1;
                this.criar = true;
            }
            this.eventRegioes();
            this.openedModal = true;
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.newMaterialDownload.file = files[0];
            this.createFile(files[0]);
        },
        createFile(file) {
            this.arquivoUpload = file.name;
        },
        removeImage: function (e) {
            this.arquivoUpload = "";
        },
        postMaterial() {
            if (!this.validate()) {
                return;
            }

            var vm = this;
            var form = new FormData();

            form.append("descricao", this.newMaterialDownload.descricao);
            form.append("classe", this.newMaterialDownload.classe);
            form.append("file", this.newMaterialDownload.file);
            form.append("regiao", this.regioes);

            let url = this.criar ? "/adm/material_download" : "/adm/material_download/" + this.materiaisDownload[this.currentIndex].id;

            if (!this.criar) {
                form.append("_method", "PUT");
            }

            this.statusEnviando = true;

            axios
                .post(url, form)
                .then(function (response) {
                    vm.statusEnviando = false;
                    vm.openedModal = false;
                    vm.load();
                })
                .catch(function (error) {
                    //console.log(error);
                    alert(
                        "Houve um erro. Por favor, recarregue a página e tente novamente."
                    );
                    vm.statusEnviando = false;
                });
        },
        deleteMaterial(index) {
            let b = confirm("A ação não poderar ser desfeita, deseja DELETAR?");

            if (!b) {
                return;
            }
            var vm = this;
            var form = new FormData();
            form.append("_method", "DELETE");

            axios
                .post(
                    "/adm/material_download/" + this.materiaisDownload[index].id,
                    form
                )
                .then(function (response) {
                    vm.load();
                })
                .catch(function (error) {
                    console.log(error);
                    //alert("Houve um erro. Por favor, recarregue a página e tente novamente.");
                    vm.$swal({
                        title: "Erro ao carregar..",
                        text: "Deseja tentar recarregar esta página ?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Sim, recarregar!",
                        cancelButtonText: "Não, deixar como está!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true,
                    }).then((result) => {
                        if (result.value) {
                            window.location.reload(1);
                        }
                    });
                });
        },
        clear() {
            this.newMaterialDownloadimage = "";
            this.newMaterialDownload.descricao = "";
            this.newMaterialDownload.classe = "";
            this.arquivoUpload = "";
            this.regioes = [];
        },
        validate() {
            if (!this.newMaterialDownload.descricao) {
                //alert('Descrição Obigatório!');
                this.$swal("Ops", "Descrição Obigatório!", "error");
                return false;
            }
            if (!this.newMaterialDownload.classe) {                
                this.$swal("Erro", "Classe Obigatório!", "error");
                return false;
            }
            if (
                (this.criar && !this.newMaterialDownload.file) ||
                this.newMaterialDownload.file.size > 60000000
            ) {
                //alert('Arquivo Obigatório com limite de 60 MB!');
                this.$swal("Ops", "Arquivo Obigatório com limite de 60 MB!", "error");
                return false;
            }
            return true;
        },
        regiaoModel(model) {
            this.regioes = model;
        },
        alteraRegiao(value) {
            this.regioes = value;
        },
    },
    mounted() {
        this.load();
        this.loadRegioes();
    },
};
</script>

<style scoped>
img {
    max-width: 64px;
    margin: auto;
    display: block;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/material_download/Main.vue